import {
  Component,
  Input
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule, FormsModule
} from '@angular/forms';

import { SWDynamicAutocompleteComponent }
from '../../../partials/components/sw-autocomplete/sw-autocomplete.component';

import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseFieldRenderer } from '../../../core/runtime/base/base-field-renderer';

@Component({
  selector: 'app-autocomplete-renderer',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    SWDynamicAutocompleteComponent
  ],
  templateUrl:'./autocomplete-renderer.component.html'
})
export class AutocompleteRendererComponent
extends BaseFieldRenderer {
}